import { customFetch } from "../../utils/Auth";
import { environment } from "../../config/environment";

const base = `${environment.apiUrl}/commercial-financial-review`;

const get = async (endpoint) => {
  const res = await customFetch(`${base}${endpoint}`, { cache: "no-store" });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Commercial Financial Review request failed (${res.status})`);
  }
  return res.json();
};

const post = async (endpoint, body) => {
  const res = await customFetch(`${base}${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) {
    const responseBody = await res.json().catch(() => ({}));
    throw new Error(responseBody.error || `Commercial Financial Review request failed (${res.status})`);
  }
  return res.json();
};

const appendList = (params, key, value) => {
  const list = Array.isArray(value) ? value : value != null && value !== "" ? [value] : [];
  list.forEach((v) => {
    if (v != null && v !== "") params.append(key, v);
  });
};

const buildParams = ({ super_org, specialty, report_month, start_month, end_month } = {}) => {
  const params = new URLSearchParams();
  appendList(params, "super_org", super_org);
  appendList(params, "specialty", specialty);
  if (report_month) params.set("report_month", report_month);
  if (start_month) params.set("start_month", start_month);
  if (end_month) params.set("end_month", end_month);
  return params.toString();
};

export const fetchFilters = (filters) => get(`/filters?${buildParams(filters)}`);
export const fetchReport = (filters) => get(`/financialreview?${buildParams(filters)}`);
export const fetchAnalysis = (filters) => get(`/analysis?${buildParams(filters)}`);
export const fetchRetention = (filters) => get(`/retention?${buildParams(filters)}`);
export const fetchLtv = (filters) => get(`/ltv?${buildParams(filters)}`);
export const fetchLtvProviders = ({ super_org, specialty, q, offset = 0, limit = 10 } = {}) => {
  const params = new URLSearchParams(buildParams({ super_org, specialty }));
  if (q) params.set("q", q);
  params.set("offset", String(offset));
  params.set("limit", String(limit));
  return get(`/ltv/providers?${params.toString()}`);
};
export const logRevopsMapping = ({ doctor_id, specialty, org }) =>
  post("/revops-mapping", { doctor_id, specialty, org });
export const logRevopsPricing = ({ super_org, cost_per_user }) =>
  post("/revops-pricing", { super_org, cost_per_user });
